<script>
  import findSector from "../../../../helpers/findSector";
  import Filter from "./Filter.svelte";
  import { appState, queryState } from "../../../../stores";

  // State
  $: activeFilters = Object.entries($queryState)
    .map((tuple) => ({
      type: tuple[0],
      filters: tuple[1],
    }))
    .filter(
      (obj) => obj.filters && !["search", "sort", "pg"].includes(obj.type)
    )
    .reduce(
      (acc, curr) => [
        ...acc,
        ...curr.filters.map((id) => {
          const key = curr.type === "sectorIds" ? "sectors" : curr.type;
          return {
            id,
            ...$appState.updatedFilters?.[key].find(
              (filter) => filter.id === id
            ),
            type: curr.type,
          };
        }),
      ],
      []
    )
    .map((filter) => {
      if (filter.type === "sectorIds")
        filter.name = findSector("id", filter.id, "title") ?? filter.name;
      if (filter.type === "organizations" && !filter.name) {
        if (sessionStorage.getItem("organizations")) {
          filter.name = JSON.parse(
            sessionStorage.getItem("organizations")
          )?.find((org) => org.id === filter.id)?.name;
        }
      }
      if (filter.type === "fiscalYears") filter.name = filter.id.toString();
      return filter;
    });

  // Actions
  const removeFilter = (filterObj) => {
    const { type, id: thisId } = filterObj;
    let newState = $queryState[type].filter((id) => id !== thisId);
    if (!newState.length) newState = null;
    $queryState[type] = newState;
  };
  const clearFilters = () => {
    queryState.update((queryState) => ({
      ...queryState,
      sectorIds: null,
      reportTypes: null,
      publishedYears: null,
      fiscalYears: null,
      organizations: null,
    }));
  };
</script>

{#if activeFilters.length}
  <div id="active-filters">
    {#each activeFilters as activeFilter}
      <Filter
        filterName={activeFilter.name}
        remove={() => removeFilter(activeFilter)}
      />
    {/each}
    <button
      id="active-filters-clear-btn"
      on:click|preventDefault={() => clearFilters()}
    >
      Clear All Filters
    </button>
  </div>
{/if}

<style>
  #active-filters {
    display: flex;
    flex-wrap: wrap;
  }

  #active-filters-clear-btn {
    border: none;
    background: transparent;
    font-family: "Segoe UI", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #d07743;
    cursor: pointer;
  }

  @media (max-width: 980px) {
    #active-filters {
      width: 100vw;
      position: relative;
      left: -30px;
      padding: 0 30px 30px;
      border-bottom: 2px solid #ebe9e9;
      margin-bottom: 30px;
    }
    #active-filters :global(p) {
      padding: 4px 0;
    }
    #active-filters-clear-btn {
      padding: 4px;
    }
  }
</style>
